<template>
    <div class="option-button-container"
        :class="{'expand-list' : showOptions }"
        v-click-outside="closeOptions">
        <button
            class="cart-option-button"
            :class="{ disabled: disabled }"
            @click="!disabled && openOptionList()"
        >
            <span class="label" :class="{ 'has-option': selected && option }"> {{ label }} </span>
            <span class="option"> {{ option }} </span>
            <i class="prz-chevron-down"/>
        </button>
        <ul v-if="optionList && !isQtySelect" class="option-list themed-scrollbar" :class="{'show-list': showOptions}">
            <li class="item opt-header" @click="closeOptions"> {{ label }} <i class="prz-chevron-down"/> </li>
            <li
                v-for="(opt, index) of optionList"
                :key="opt.id"
                :value="opt.id"
                :data-id="opt.id"
                :data-order="index"
                :data-isdefaultsku="opt.default"
                class="item"
                :class="{'no-stock' : !opt.stock}"
                @click= "opt != selected ? getOptionObj(opt) : closeOptions()"
            >
                <p>
                    {{ optionLabel(opt)}}
                </p>
                <span v-if="showStockWarningLabels && opt.stockRemainingLabel" class="stock-alert"> {{ opt.stockRemainingLabel }} </span>
                <span v-if="enableStockAlert && !opt.stock" class="label-out-of-stock"> {{ stockLabel(opt)}} </span>
                <i v-if="option && (opt.id == (selected && selected.id))" class="prz-checkmark"/>
            </li>
        </ul>
        <ul v-if="isQtySelect" class="option-list themed-scrollbar" :class="{'show-list': showOptions}">
            <li
                v-for="n in getNumbers(1, this.qtyLimit)"
                :key="n"
                :value="n"
                @click="getOptionObj(n)"
                class="item"
            >
                <p>
                    {{n}}
                </p>
                <i v-if="selected == n" class="prz-checkmark"/>
            </li>
        </ul>
    </div>
</template>

<script>

import { clickOutside } from '@/api/vueDirectives';
import {storePdp} from '@/store/product-page';
import { isEqual } from "lodash-es";

export default {
    storePdp,
    name: 'OptionBtn',
    components: {},
    props: {
        label: {
            type: String,
            default: '',
        },
        option: {
            type: String,
            default: '',
        },
        selectionType: {
            type: String,
            default: 'primary',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        itemIndex: { // for multiple widgets
            type: [Number, String],
            default: 0,
        },
        isQtySelect: {
            type: Boolean,
            default: false,
        },
        defaultValue: {
            type: [Number, Object],
            default: null,
        },
        optionList: {
            type: Array,
            default: () => []
        },
        qtyLimit: {
            type: Number,
            default: 5,
        },
        showStockWarningLabels: { // ex: in case of primary and secondary options (hides in primary -> can confuse the client)
            type: Boolean,
            default: true,
        }
    },
    data: function() {
        return {
            showOptions: false,
            selected: this.defaultValue ? this.defaultValue : ( this.isQtySelect ? 1 : null ),
        };
    },

    computed: {
        kStrings() {
            return storePdp.getters.kStrings;
        },
        enableStockAlert() {
            return storePdp.getters['pdpDesktop/enableStockAlert'];
        }
    },
    methods: {
        isEqual,
        openOptionList() {
            this.showOptions = !this.showOptions;
        },
        getOptionObj: function(option, single = false) {
            this.selected = option;
            this.$emit('input', this.selected);
            this.$emit('update-current-option', this.selectionType, this.selected);
            if(this.isQtySelect) {
                storePdp.dispatch('pdpDesktop/addToCartDesktop/updateCartItemQty', this.selected);
            }
            this.showOptions = false;
        },
        // for qty selects
        getNumbers: function(start, stop) {
            stop += 1;
            return new Array(stop - start).fill(start).map((n, i) => n + i);
        },
        closeOptions() {
            this.showOptions = false;
        },
        optionLabel: function (opt) {
            if (this.enableStockAlert) {
                return opt.description;
            }

            if (!opt.stock && opt.displayType == 'LAYOUT_PROMOTER_NOT_ELIGIBLE') {
                return opt.description;
            } else if (opt.stock) {
                return opt.description;
            } else {
                return opt.description + ' - ' + this.kStrings.kPROD_STOCK_OUT;
            }
        },
        stockLabel(opt) {
            if(opt.displayType == 'LAYOUT_PROMOTER_NOT_ELIGIBLE'){
                return this.kStrings.KNOT_ELIGIBLE;
            }
            return this.kStrings.kPROD_STOCK_OUT;
        }
    },
    watch: {},

    mounted() {
        this.$nextTick(() => {
            if(this.isQtySelect && this.selected > 1) {
                this.$emit('input', this.selected);
                storePdp.dispatch('pdpDesktop/addToCartDesktop/updateCartItemQty', this.selected);
            }
        });
    },
};
</script>

<style lang="scss">

</style>
